import React from 'react'
import CompanyParentCard from './scenes/UI/CompanyParentCard'
import HumanEntity from './scenes/UI/HumanEntity'

type Props = {
  displayState: any
  nodeDatum: any
  onOpenHierarchyWalkdown?: () => void
}

const CardParentFactory = ({
  displayState,
  nodeDatum,
  onOpenHierarchyWalkdown,
}: Props) => {
  switch (nodeDatum?.type) {
    case 'COMPANY':
      return (
        <CompanyParentCard
          displayState={displayState}
          nodeDatum={nodeDatum}
          onOpenHierarchyWalkdown={onOpenHierarchyWalkdown}
        />
      )
    case 'LEGAL_OWNER':
    case 'BENEFICIAL_OWNER':
    case 'BENEFICIAL_OWNER_AND_LEGAL_OWNER':
      return (
        <HumanEntity
          displayState={displayState}
          nodeDatum={nodeDatum}
          onOpenHierarchyWalkdown={onOpenHierarchyWalkdown}
        />
      )
    default:
      return <div>No such type</div>
  }
}

export default CardParentFactory
